export default {
  infoTitle: {
    id: 'insurance_drawer_us_faq_title',
    defaultMessage: 'Frequently Asked Questions',
  },
  infoQuestion1: {
    id: 'insurance_drawer_us_faq_question1',
    defaultMessage: 'What does the protection plan cover?',
  },
  infoResponse1: {
    id: 'insurance_drawer_us_faq_response1',
    defaultMessage:
      "The plan covers manufacturing defects and accidental damage from normal use (drops, spills, cracked screens, and power surges). A warranty extension also kicks in after your 1-year warranty expires, so you're not left unprotected over time. Not covered: theft and loss, cosmetic damage that doesn't affect your device's function (light scratches, minor scuffs), and intentional damage.",
  },
  infoQuestion2: {
    id: 'insurance_drawer_us_faq_question2',
    defaultMessage: 'How is this different from my Commercial warranty?',
  },
  infoResponse2: {
    id: 'insurance_drawer_us_faq_response2',
    defaultMessage:
      "Back Market's commercial warranty comes free with every purchase and covers manufacturing defects — things that were wrong before you received the device. BackUp goes further: it covers accidental damage from everyday use (drops, spills, cracked screens) and extends protection after your commercial warranty expires.",
  },
  infoQuestion3: {
    id: 'insurance_drawer_us_faq_question3',
    defaultMessage: 'Is there a service fee when I make a claim?',
  },
  infoResponse3: {
    id: 'insurance_drawer_us_faq_response3',
    defaultMessage:
      "Smartphone claims include a service fee, paid by credit or debit card before repair or reimbursement. The fee varies based on your device's purchase price and whether it's repaired or replaced. No service fee applies to tablets, laptops, or other devices.",
  },
  infoQuestion4: {
    id: 'insurance_drawer_us_faq_question4',
    defaultMessage: 'How do I make a claim?',
  },
  infoResponse4: {
    id: 'insurance_drawer_us_faq_response4',
    defaultMessage:
      "File a claim through Bolt, our insurance partner. They'll get back to you within 24 hours. If your device is eligible for repair, choose between dropping it off at a local repair shop or using a free prepaid shipping label. After diagnosis, if your device can't be repaired, you'll receive a payment for your device's purchase price (minus tax) toward a replacement.",
  },
  infoQuestion5: {
    id: 'insurance_drawer_us_faq_question5',
    defaultMessage: 'Can I cancel my plan?',
  },
  infoResponse5: {
    id: 'insurance_drawer_us_faq_response5',
    defaultMessage:
      "Yes, you can cancel anytime. If you cancel after the 30-day withdrawal period, you'll receive a partial refund for the unused portion of your plan.",
  },
  infoQuestion6: {
    id: 'insurance_drawer_us_faq_question6',
    defaultMessage:
      "What's the difference between the monthly and yearly plans?",
  },
  infoResponse6part1: {
    id: 'insurance_drawer_us_faq_response6_part1',
    defaultMessage:
      'Both plans include identical coverage. The difference is how you pay:',
  },
  infoResponse6part2: {
    id: 'insurance_drawer_us_faq_response6_part2',
    defaultMessage:
      "The 2-year plan works out cheaper over 24 months. And you're not locked in: cancel the auto-renewal before it kicks in for a full refund within 30 days of renewal — or cancel anytime for a partial refund on unused time.",
  },
  infoResponse6Monthly: {
    id: 'insurance_drawer_us_faq_response6_monthly',
    defaultMessage: 'Monthly: pay each month. Cancel anytime.',
  },
  infoResponse6TwoYears: {
    id: 'insurance_drawer_us_faq_response6_two_year',
    defaultMessage:
      '2-year: one upfront payment. Renews automatically after the end of the 2 years.',
  },
}
